import { Component } from '@angular/core';

/**
 * Composant affichant la page 404.
 */
@Component({
  selector: 'no-content',
  template: `
    <div>
      <h1>404: page missing</h1>
    </div>
  `
})
export class NoContentComponent {

}
